module.exports = __webpack_public_path__ + "img/javascript.7c14494c.svg";